import { useCallback, useMemo, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useDormitoryRequests(defaultLoading: boolean = false) {
  const [requests, setRequests] = useState<DormitoryRequestEntity[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(defaultLoading);

  const fetchDormitoryRequests = useCallback(async () => {
    setLoading(true);
    try {
      const response = await DormitoryLegacyHttp.fetchDormitoryRequests();
      setRequests(response.data?.payload ?? []);
    }
    catch (e) {
      setRequests([]);
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  const findRequestBySemesters = useCallback((semesters: DormitorySemesterEntity[] = [], onlyAccepted = false) => {
    const validIds = semesters.map(s => s.id);
    let request: DormitoryRequestEntity;
    if (onlyAccepted) {
      request = requests.find(r => r.status ==='ACCEPT' && validIds.includes(r.semester.id));
    }
    else {
      request = requests.find(r => validIds.includes(r.semester.id));
    }
    return request;
  }, [requests]);

  const currentSemesterRequest: DormitoryRequestEntity = useMemo(() => {
    return requests.find(x => x?.semester?.currentSemester === true) ?? null;
  }, [requests]);

  return { requests, currentSemesterRequest, fetchDormitoryRequests, findRequestBySemesters, loading, error };
}
